export const detectMobile = () => ({
	type: 'DETECT_MOBILE',
})
